export enum IgnoredHttpCodes  {
    NETWORK_TIMEOUT = -1,
    UNKNOWN = 0,
    UNAVAILABLE = 502,
    MAINTENANCE = 503
}
